import React from 'react';
import { useTranslation } from 'react-i18next';
import 'react-responsive';
import { DeprecatedFAIcon } from '@components-library/Icons/DeprecatedFAIcon';
import { SvgIcon } from '@components-library/Icons/SvgIcon';
import { DEPRECATED_FA_GLOBAL_SPRITE } from '@components-library/Icons/interfaces';
import { TextCollapse } from '@components-library/TextCollapse';
import { keyMap } from '@locales/lokalise/keyMap';
import { copyToClipboard } from '@utils/helper';
import errorImage from 'assets/error-image.withAttrs.svg';
import styles from './errorLayout.module.scss';

interface IErrorMessage {
  message?: string;
  stack?: string | null;
}

export const ErrorLayout = ({ message, stack }: IErrorMessage) => {
  const { i18n } = useTranslation();
  const refreshButtonHandler = () => {
    window.location.reload();
  };

  const copyButtonHandler = () => {
    copyToClipboard(`${message ?? ''}\n${stack ?? ''}`);
  };

  return (
    <div className={styles.errorLayout}>
      <div className={styles.errorLayout__wrapper}>
        <h1 className={styles.errorLayout__title}>{i18n.t(keyMap.sharedSystemSomethingWentWrong)}</h1>
        <p className={styles.errorLayout__subtitle}> {i18n.t(keyMap.sharedSystemRefreshPage)}</p>
        <div>
          <TextCollapse collapsedHeight={0} className={styles.errorLayout__error}>
            {message && <p>{message}</p>}
            {stack && (
              <>
                <b> {i18n.t(keyMap.sharedSystemErrorOccurred)}</b>:<p>{stack}</p>
              </>
            )}
          </TextCollapse>
        </div>
        <button onClick={copyButtonHandler} className={styles.errorLayout__button}>
          <DeprecatedFAIcon icon={DEPRECATED_FA_GLOBAL_SPRITE.copy} />
          {i18n.t(keyMap.sharedActionsCopy)}
        </button>
        <div className={styles.errorLayout__buttonWrapper}>
          <button className={styles.errorLayout__refresh} onClick={refreshButtonHandler}>
            {i18n.t(keyMap.sharedSystemRefreshButton)}
          </button>
        </div>
      </div>
      <SvgIcon className={styles.errorLayout__image} src={errorImage} />
    </div>
  );
};
